// A crisis plan row stacks six editors, so they sit shorter than the default 160px.
export const CRISIS_PLAN_RICH_TEXT_MIN_HEIGHT = 96;

export const CRISIS_PLAN_RICH_TEXT_MIN_LENGTH = 60;

export const EMPTY_CRISIS_PLAN_VALUES = {
  assessment_behavior_id: '',
  crisis_creation_date: null,
  operational_definition: '',
  antecedent_interventions: '',
  precursors_action_steps: '',
  escalation_intervention_plan: '',
  follow_up_steps: '',
  functional_behavior: '',
  consequence_strategies: '',
} as const;

export const CRISIS_PLAN_FUNCTIONAL_BEHAVIOR_OPTIONS = [
  { value: 'Escape-Maintained', label: 'Escape-Maintained' },
  { value: 'Attention-Maintained', label: 'Attention-Maintained' },
  { value: 'Tangible-Maintained', label: 'Tangible-Maintained' },
  { value: 'Sensory-Maintained', label: 'Sensory-Maintained' },
] as const;

export const LEGACY_CRISIS_PLAN_FUNCTIONAL_BEHAVIOR = {
  sensory: 'Sensory-Maintained',
  escape_avoidance: 'Escape-Maintained',
  attention: 'Attention-Maintained',
  tangible: 'Tangible-Maintained',
} as const;
